// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 0,
  pageSize: 20,
  customFilters: [],
  value: "",
  sorting: [],
  sortField: "nom",
  sortOrder: "asc",
  activeTab: "details",
  //Nouveau
  query: "",
  actif: {},
  selectedOptionFilters: null,
  selectedOptionId: null,
  column: [],
};

const FiltreInvestisseurs = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_INVESTISSEUR:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_INVESTISSEUR:
      return {
        ...state,
        currentPage: action.payload,
      };
    case actionTypes.SET_CUSTOM_FILTERS_INVESTISSEUR:
      return {
        ...state,
        customFilters: action.payload,
      };
    case actionTypes.SET_SORT_FIELD_INVESTISSEUR:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_PAGE_SIZE_INVESTISSEUR:
      return {
        ...state,
        pageSize: action.payload,
      };
    case actionTypes.SET_SORTING_INVESTISSEUR:
      return {
        ...state,
        sorting: action.payload,
      };
    case actionTypes.SET_ORDER_INVESTISSEUR:
      return {
        ...state,
        sortOrder: action.payload,
      };
    case actionTypes.SET_ACTIVE_TAB_INVESTISSEUR:
      return {
        ...state,
        activeTab: action.payload,
      };
    case actionTypes.SET_QUERY_INVESTISSEUR:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.SET_ACTIF_INVESTISSEUR:
      return {
        ...state,
        actif: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_FILTERS_INVESTISSEUR:
      return {
        ...state,
        selectedOptionFilters: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_ID_INVESTISSEUR:
      return {
        ...state,
        selectedOptionId: action.payload,
      };
    case actionTypes.SET_COLUMN_INVESTISSEUR:
      return {
        ...state,
        column: action.payload,
      };
    default:
      return state;
  }
};

export default FiltreInvestisseurs;
